// extracted by mini-css-extract-plugin
export var claimBtn = "RebuyRecommended-module--claimBtn--5ptN8";
export var pdSale = "RebuyRecommended-module--pdSale--z4LDJ";
export var pdSlash = "RebuyRecommended-module--pdSlash--KEAeV";
export var productInfo = "RebuyRecommended-module--productInfo--HqAkW";
export var sliderItemContainer = "RebuyRecommended-module--sliderItemContainer--FajbD";
export var titlePriceContainer = "RebuyRecommended-module--titlePriceContainer--MIVGV";